<style lang="scss">
@import "../styles/payment-v2/payment-menu-content-form-bank-transfer.scss";
@import "@/styles/_mixins.scss";
.form-offset-right {
  padding-right: 0;
  @include tablet {
    padding-right: 16px;
  }
}
</style>

<template>
  <v-form
    v-if="isVisible"
    ref="form"
    class="payment-menu-content-form-bank-transfer"
    @submit.prevent="onClickSubmitPayment"
  >
    <v-layout row wrap>
      <v-flex v-if="!new_payment_ui && !isRenewalPayment" xs12 md6 class="form-offset-right">
        <PaymentMenuContentSummary
          :subscription-ids="subscriptionIds"
          :default-payment-data="defaultPaymentData"
          :one-off-codes="oneOffCodes"
          :request-payment-items="requestPaymentItems"
          :add-shareholder-id="addShareholderId"
          :promo-code-enabled="promoCodeEnabled"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          :company-id-from-billing-profile="companyIdFromBillingProfile"
        />
      </v-flex>
      <v-flex
        :class="isRenewalPayment || isMobile ? 'xs12 md12' : 'xs6 md6'"
        class="payment-menu-content-form-bank-transfer-left-panel new-payment-ui-method"
      >
        <div class="mb-3">
          <div class="new-payment-ui-method-title">
            {{ $t("$onboarding.content_paragraph.payment.summary.mode_of_payment.title") }}
          </div>
          <PaymentMethodSelect :payment-methods-topic="paymentMethodsTopic" paymentMethodSelected="bank_transfer" />
        </div>
        <div>
          <div>
            <div v-if="!isPartnerBillingProfilePayment" class="content grayed">
              {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.text_1") }}
            </div>
            <div v-if="isPartnerBillingProfilePayment" class="content">
              Please include your company name or invoice number (if paying later) for us to identify you.
            </div>
            <div v-else class="content">
              {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.text_2") }}
            </div>
            <div class="content blued">
              <div class="content-title">
                {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.labels.bank_transfer") }}
              </div>
              <table>
                <tr>
                  <td class="col-left">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.labels.bank") }}
                  </td>
                  <td class="col-right">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.values.bank_name") }}
                  </td>
                </tr>
                <tr>
                  <td class="col-left">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.labels.recipient") }}
                  </td>
                  <td class="col-right">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.values.account_name") }}
                  </td>
                </tr>
                <tr>
                  <td class="col-left">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.labels.account_number") }}
                  </td>
                  <td class="col-right">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.values.account_number") }}
                  </td>
                </tr>
                <tr>
                  <td class="col-left">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.values.code_label") }}
                  </td>
                  <td class="col-right">
                    {{ $t("$onboarding.content_paragraph.payment.bank_transfer.bank_details.values.swift_code") }}
                  </td>
                </tr>
              </table>
            </div>
            <div v-if="!isPartnerBillingProfilePayment && paynowEnabled" class="content blued">
              <div class="content-title">
                <img src="/imgs/payment/paynow-logo.svg" alt="PAYNOW" valign="middle" />
                (Next working day)
              </div>
              <table>
                <tr>
                  <td class="col-left">UEN</td>
                  <td class="col-right">{{ bankDetails.uen_paynow }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="new-payment-ui-method-actions">
          <v-layout>
            <v-flex>
              <v-btn v-if="hasBackButtonListener" color="primary" outline type="button" @click="onBackEvent()"
                ><v-icon left dark>keyboard_arrow_left</v-icon>{{ $t("$onboarding.card.buttons.back") }}</v-btn
              >
            </v-flex>
            <v-flex shrink>
              <v-btn :loading="isButtonLoading" color="primary" type="submit">
                <span class="text-uppercase font-weight-bold">{{
                  $t("$onboarding.card.buttons.email_invoice_to_me")
                }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
/* eslint-disable */
import { get, pickBy, isEmpty } from "lodash";

// Proxies
import ApplyForManualPaymentProxy from "@/proxies/back-end/manual-payment/apply-for-external-payment";
import ApplyForSubscriptionManualPaymentProxy from "@/proxies/back-end/subscriptions/apply-for-external-payment";
import UserPreferenceByCompanyProxy from "@/proxies/back-end/users/user-preference-by-company";
import AllTypePaymentPostProxy from "@/proxies/back-end/subscriptions/payment-all-type";
import UpdatePaymentRequestByTokenProxy from "@/proxies/back-end/payment-request/update";
import addNewShareholder from "@/proxies/back-end/workflow/add-new-shareholder/add-new-shareholder";
import GetCompanyProxy from "@/proxies/back-end/company/get";

// Components
import PaymentMenuContentSummary from "./PaymentMenuContentSummary.vue";
import PaymentMethodSelect from "./PaymentMenuContentPaymentMethod.vue";
import DatePicker from "@shared-components/presentational/DatePicker.vue";

// Mapping
import GlobalTopic from "@/utilities/global-topic";
import LocalStoreManager from "@/utilities/local-store-manager";
import ShoppingCartManager from "@/utilities/shopping-cart-manager";
import { getAppFeatureProp } from "@/utilities/app-feature-util";

// Mixins
import { GoogleAnalyticsMixin } from "@/mixins/googleAnalytics";
import { ConfigMixin } from "@/mixins/config-mixin";

import { handleTask } from "@/utilities/workflow-task-handler";
import { Constants } from "customer-sdk/constants";

const { WORKFLOW_CONSTANTS } = Constants.WORK_FLOW;
const EVENTS = Constants.EVENTS;
const PAGE_URLS = Constants.PAGE_URLS;
const ERROR_MESSAGES = Constants.ERROR_MESSAGES;
const ON_BOARDING_EVENTS = Constants.ON_BOARDING_EVENTS;
const PAYMENT_METHODS_EVENTS = Constants.ON_BOARDING_PAYMENT_METHODS_EVENTS;
const { COMPANY_USER_MODULE, COMPANY_USERS } = Constants.COMPANY_USERS_CONSTANTS;

//#region private variables
let POST_PAYMENT_PATH = "/processing-payment";
let NEW_POST_PAYMENT_PATH = PAGE_URLS.INCORPORATION;
let INVALID_DATE_INPUT = "expected_pay_at: Invalid date";
let store = new LocalStoreManager();
//#endregion

//#region private methods

let renderIssueMessage = (message, timeout) => {
  GlobalTopic.publishChange({
    type: EVENTS.ON_OPEN_SNACKBAR,
    data: {
      snackbarText: message,
      timeout: timeout
    }
  });
};

let handleApplyForManualPayment = async component => {
  try {
    let { subscriptionIds } = component;

    if (subscriptionIds && subscriptionIds.length > 0 && !component.requestPaymentId) {
      // let paymentData = await handleSubscriptionManualPayment(component);
      // component.parseGAData(paymentData);
      const paymentData = await handleSubscriptionManualPayment(component);
      if (component.task) {
        try {
          await handleTask(component.task, paymentData, WORKFLOW_CONSTANTS.PAYMENT_STATUS.PENDING);
        } catch (error) {
          console.log("error", error);
        }
      } else {
        if (component.isPartnerBillingProfilePayment) {
          component.$emit("displayAfterPaymentScreen", { paymentMethod: "manualPayment" });
        } else {
          component.$router.push(PAGE_URLS.POST_RENEWAL_PAYMENT);
        }
      }
      return;
    } else if (
      component.requestPaymentId ||
      (subscriptionIds && subscriptionIds.length === 0 && component.oneOffCodes)
    ) {
      await handleOneOffManualPaymentFromPaymentRequest(component);

      if (component.requestPaymentId) {
        let proxy = new UpdatePaymentRequestByTokenProxy();

        const request_payment_status = getAppFeatureProp(
          component.platformConfig.cmsGeneralFeatureList,
          "request_payment_status"
        );

        await proxy.updateRecord(component.defaultPaymentData, {
          paymentRequestId: component.requestPaymentId,
          status: request_payment_status.value.USED
        });
      }

      if (component.accountingSetupOptions) {
        const { redirect, openedPage, questionnaire_token, email } = component.accountingSetupOptions;
        await component.updateQuestionnaireMultiCurrency(openedPage);
        const urlParams = new URLSearchParams(pickBy({ redirect, openedPage, questionnaire_token, email }));
        component.$router.push(`${PAGE_URLS.POST_RENEWAL_PAYMENT}?${urlParams}`);
      } else {
        component.$router.push(`${PAGE_URLS.POST_PAYMENT_REQUEST}`);
      }
    } else if (!isEmpty(component.unpaidBillsDetails)) {
      try {
        let paymentData = await handleUnpaidBillManualPayment(component);
        component.$router.push(`${PAGE_URLS.POST_RENEWAL_PAYMENT}`);
      } catch (error) {
        console.log("error", error);
      }
    } else if (component.upgradeCorpSecSubscription) {
      const companyUsers = component.$store.getters[`${COMPANY_USER_MODULE}/${COMPANY_USERS}`];

      let paymentData = await handleUpgradeCorpSecSubscriptionManualPayment(component);
      try {
        await handleTask(component.task, paymentData, WORKFLOW_CONSTANTS.PAYMENT_STATUS.PENDING, companyUsers);
      } catch (error) {
        console.log("error", error);
      }
    } else if (component.addShareholderId) {
      let paymentData = await handleShareholderManualPayment(component);
      component.parseGAData(paymentData);
      component.$router.push(`${PAGE_URLS.POST_REQUEST_SHAREHOLDER}?paidWith=bank`);
    } else if (component.isPartnerPayment) {
      await handleOnboardingManualPayment(component);
      publishPaymentSubmitted(component);
    } else {
      // let paymentData = await handleOnboardingManualPayment(component);
      // component.parseGAData(paymentData);
      await handleOnboardingManualPayment(component);

      const new_dashboard_onboarding_enabled = getAppFeatureProp(
        component.platformConfig.cmsAppFeatures,
        "new_dashboard_onboarding_enabled"
      );

      const isNewUiEnabled = new_dashboard_onboarding_enabled.enabled;

      const new_payment_page_enabled = getAppFeatureProp(
        component.platformConfig.cmsAppFeatures,
        "new_payment_page_enabled"
      );

      const isNewPaymentPage = new_payment_page_enabled.enabled;
      if (isNewUiEnabled) {
        if (isNewPaymentPage) {
          component.$store.dispatch("companyUsersModule/hideShoppingCartAfterPayment");
          component.$store.dispatch("companyUsersModule/hideShoppingCartDropdown");
          component.$emit("displayAfterPaymentScreen", { paymentMethod: "manualPayment" });
        } else {
          component.$router.push(`${NEW_POST_PAYMENT_PATH}?isInitial=true`);
        }
      } else {
        component.$router.push(`${POST_PAYMENT_PATH}?isInitial=true`);
      }
    }
  } catch (error) {
    if (error.message == INVALID_DATE_INPUT) {
      publishSubmitPaymentError(component, ERROR_MESSAGES.MANUAL_PAYMENT.INVALID_PAYMENT_DATE_INPUT);
    }

    throw error;
  }
};

let handleOnboardingManualPayment = async component => {
  try {
    let proxy = new ApplyForManualPaymentProxy();
    let payload = {
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber
    };
    return await proxy.execute(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

let handleSubscriptionManualPayment = async component => {
  try {
    let proxy = new ApplyForSubscriptionManualPaymentProxy();
    let payload = {
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber,
      companySubscriptionIds: component.subscriptionIds,
      isPartnerBillingProfilePayment: component.isPartnerBillingProfilePayment
    };
    return await proxy.execute(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

const handleUnpaidBillManualPayment = async component => {
  const proxy = new AllTypePaymentPostProxy();
  const company_id = component.defaultPaymentData.id;
  try {
    let payload = {
      company_id,
      unpaidBillsDetails: component.unpaidBillsDetails
    };

    return await proxy.unpaidBillManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    initCreatePaymentToken(component);
    throw error;
  }
};

let handleUpgradeCorpSecSubscriptionManualPayment = async component => {
  const proxy = new AllTypePaymentPostProxy();
  const companyId = component.defaultPaymentData.id;
  const amendCompanyShareStructureData = localStorage.getItem(`amendCompanyShareStructureData_${companyId}`);
  const shareholders = get(JSON.parse(amendCompanyShareStructureData), "shareholders", []);
  const totalNumberOfShareholder = shareholders.filter(shareholder => !shareholder.is_removed).length;

  try {
    const payload = {
      company_id: companyId,
      total_number_of_shareholder: totalNumberOfShareholder
    };
    return await proxy.upgradeCorpSecSubscriptionManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    initCreatePaymentToken(component);
    throw error;
  }
};

let handleOneOffManualPaymentFromPaymentRequest = async component => {
  try {
    let proxy = new AllTypePaymentPostProxy();
    let payload = {
      companySubscriptionIds: component.subscriptionIds,
      oneOffCodes: component.oneOffCodes,
      companyId: localStorage.getItem("paymentRequestCompanyId")
        ? localStorage.getItem("paymentRequestCompanyId")
        : localStorage.getItem("companyId"),
      requestPaymentId: component.requestPaymentId,
      requestPaymentItems: component.requestPaymentItems,
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber
    };
    return await proxy.postManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

let buildPayload = async component => {
  const cart = new ShoppingCartManager();
  let response = await cart.fetchUpgradeCorpsecSubscriptionDetails(component.addShareholderId);
  let companyProxy = new GetCompanyProxy();
  let company = await companyProxy.execute({ id: await store.getCompanyId(), authToken: store.getToken() });

  const companyId =
    localStorage.getItem("paymentRequestCompanyId") && localStorage.getItem("paymentRequestCompanyId") != "null"
      ? localStorage.getItem("paymentRequestCompanyId")
      : localStorage.getItem("companyId");
  const payload = {
    authToken: store.getToken(),
    payload: {
      requested_by_user_id: store.getUserId(),
      requested_by_user_name: store.getUserEmail(),
      company_user_id: store.getUserId(),
      company_user_name: store.getUserEmail(),
      company_id: companyId,
      company_name: company ? company.name : "",
      price: response ? response.shoppingCartTotal : 0,
      company_workflow_data: {
        request_information: {
          request_type: "addition_of_shareholder",
          company_id: companyId,
          company_name: company ? company.name : "",
          requested_by_user_id: store.getUserId()
        }
      }
    }
  };
  return payload;
};

let handleShareholderManualPayment = async component => {
  try {
    let proxy = new AllTypePaymentPostProxy();
    let payload = {
      addShareholderId: component.addShareholderId,
      companyId: localStorage.getItem("paymentRequestCompanyId")
        ? localStorage.getItem("paymentRequestCompanyId")
        : localStorage.getItem("companyId"),
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber
    };
    // start workflow
    let workflowPayload = await buildPayload(component);
    await addNewShareholder.startAdditionOfShareholder(workflowPayload);

    return await proxy.postUpgradeManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

let publishSubmitPaymentError = (component, message) => {
  let { paymentMethodsTopic } = component;
  if (paymentMethodsTopic) {
    paymentMethodsTopic.publish({
      type: PAYMENT_METHODS_EVENTS.ON_SUBMIT_PAYMENT_ERROR,
      data: message
    });
  }
};

let subscribeToTopic = component => {
  if (component.paymentMethodsTopic) {
    component.paymentMethodsTopic.subscribe(msg => {
      if (msg.type === PAYMENT_METHODS_EVENTS.ON_EXISTING_CARD_SELECTED) {
        component.isVisible = false;
      } else if (msg.type === PAYMENT_METHODS_EVENTS.ON_ADD_NEW_CARD_SELECTED) {
        component.isVisible = false;
      } else if (msg.type === PAYMENT_METHODS_EVENTS.ON_BANK_TRANSFER_CLICKED) {
        component.isVisible = true;
      }
    });
  }
};

let getComponentData = component => {
  return {
    lastDoneStep: 4
  };
};

let publishPaymentSubmitted = component => {
  if (component.onBoardingTopic) {
    component.onBoardingTopic.publish({
      type: ON_BOARDING_EVENTS.ON_PAYMENT_SUBMITTED,
      data: getComponentData(component)
    });
  }
};
//#endregion
const checkUI = async component => {
  const isPartner = await store.getPartnerId();
  const new_payment_ui = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "new_payment_ui");
  component.new_payment_ui = new_payment_ui.enabled && (!isPartner || isPartner == "null");
};
export default {
  components: {
    PaymentMenuContentSummary,
    DatePicker,
    PaymentMethodSelect
  },
  mixins: [GoogleAnalyticsMixin, ConfigMixin],
  props: {
    onBoardingTopic: Object,
    paymentMethodsTopic: Object,
    defaultPaymentData: Object,
    subscriptionIds: Array,
    unpaidBillsDetails: Array,
    task: Object,
    oneOffCodes: Array,
    requestPaymentId: String,
    requestPaymentItems: Array,
    isPartnerPayment: Boolean,
    addShareholderId: String,
    promoCodeEnabled: Boolean,
    accountingSetupOptions: Object,
    updateQuestionnaireMultiCurrency: Function,
    isPartnerBillingProfilePayment: {
      type: Boolean,
      default: false
    },
    upgradeCorpSecSubscription: { type: Boolean, default: false },
    companyIdFromBillingProfile: String,
    // USED TO SET THE DESIGN BREAKPOINTS CLASS BASED ON PARENT COMPONENT
    isRenewalPayment: Boolean
  },
  computed: {
    bankDetails() {
      const ms_banking_details = getAppFeatureProp(this.platformConfig.cmsGeneralFeatureList, "ms_banking_details");
      const sleek_banking_details = getAppFeatureProp(
        this.platformConfig.cmsGeneralFeatureList,
        "sleek_banking_details"
      );

      return this.platformConfig && this.isPartnerBillingProfilePayment
        ? ms_banking_details.value
        : sleek_banking_details.value;
    },
    hasBackButtonListener() {
      return this.$parent.$listeners && this.$parent.$listeners.triggerBackButton instanceof Function;
    }
  },
  data() {
    const defaultForm = Object.freeze({
      dateOfPayment: "",
      chequeNumber: ""
    });
    return {
      form: Object.assign({}, defaultForm),
      isVisible: false,
      defaultForm,
      isButtonLoading: false,
      paynowEnabled: true,
      new_payment_ui: false,
      isMobile: window.innerWidth < 960,
      windowWidth: window.innerWidth
    };
  },
  methods: {
    onBackEvent: function() {
      this.$parent.$emit("triggerBackButton");
    },
    onBackClick: function(onBoardingTopic) {
      if (onBoardingTopic) {
        onBoardingTopic.publish({
          type: ON_BOARDING_EVENTS.ON_CONTACT_SELECTED
        });
      }
    },
    onClickSubmitPayment: async function() {
      let component = this;
      try {
        component.isButtonLoading = true;
        await handleApplyForManualPayment(component);
      } catch (error) {
        component.isButtonLoading = false;
        renderIssueMessage(error.message, 3000);
        throw error;
      }
    },
    onUpdateDateFormField: function(event) {
      const component = this;
      component.form.dateOfPayment = event;
    },
    handleResponsive() {
      this.windowWidth = window.innerWidth;
    }
  },
  async created() {
    const ms_banking_details = getAppFeatureProp(this.platformConfig.cmsGeneralFeatureList, "ms_banking_details");
    const sleek_banking_details = getAppFeatureProp(
      this.platformConfig.cmsGeneralFeatureList,
      "sleek_banking_details"
    );
    const bankDetails = this.platformConfig && this.isPartnerBillingProfilePayment
        ? ms_banking_details.value
        : sleek_banking_details.value;
    this.$i18n.mergeLocaleMessage("en", {
      $onboarding: {
        content_paragraph: {
          payment: {
            bank_transfer: {
              bank_details: {
                values: bankDetails
              }
            }
          }
          
        }
      }
    });
    if (this.platformConfig && !this.isPartnerBillingProfilePayment) {
      const zhBankDetails = get(sleek_banking_details, "value.zh");
      if (zhBankDetails) {
        this.$i18n.mergeLocaleMessage("zh", {
          $onboarding: {
            content_paragraph: {
              payment: {
                bank_transfer: {
                  bank_details: {
                    values: zhBankDetails
                  }
                }
              }
            }
          }
        });
      }
    }
  },
  async mounted() {
    window.addEventListener("resize", this.handleResponsive);
    subscribeToTopic(this);

    const new_dashboard_post_incorporation = getAppFeatureProp(this.platformConfig.cmsAppFeatures, "onboarding");
    const revamped_design = getAppFeatureProp(new_dashboard_post_incorporation.props, "revamped_design");
    const paynow_enabled = getAppFeatureProp(revamped_design.props, "paynow_enabled");

    this.paynowEnabled = paynow_enabled.enabled;
    await checkUI(this);
  },
  watch: {
    windowWidth(width) {
      this.isMobile = width < 1024;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResponsive);
  },
};
</script>
